var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBriefCase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2 5.47368H19.6V2.73684C19.6 1.22474 18.347 0 16.8 0H11.2C9.653 0 8.4 1.22474 8.4 2.73684V5.47368H2.8C1.253 5.47368 0.014 6.69842 0.014 8.21053L0 23.2632C0 24.7753 1.253 26 2.8 26H25.2C26.747 26 28 24.7753 28 23.2632V8.21053C28 6.69842 26.747 5.47368 25.2 5.47368ZM16.8 5.47368H11.2V2.73684H16.8V5.47368Z",
    fill: "#F8D210"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefCase);
export default __webpack_public_path__ + "static/media/brief-case.e1422d738dd71ea4e2fa415cbb5549b9.svg";
export { ForwardRef as ReactComponent };